import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  height: calc(100% - 60px);
  width: 100%;
  overflow: scroll;
  overflow-x: hidden;
  top: 60px;
  scroll-snap-type: mandatory;
  scroll-snap-points-y: repeat(100%);
  scroll-snap-type: y mandatory;
`
export { Wrapper }
